import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";
import { useParams } from "react-router-dom";

/**
 * @typedef {{ en: string, hi: string }} LangField
 */

/**
 * @typedef {object} QuizResponseItem
 * @property {number} id
 * @property {LangField|null} answerExplanation
 * @property {LangField} correctAnswer
 * @property {LangField|null} option1
 * @property {LangField|null} option2
 * @property {LangField|null} option3
 * @property {LangField|null} option4
 * @property {LangField} question
 */

/**
 * Hook to fetch Student Quiz List for a specific chapter.
 * @returns {{
 *  schlStudentQuiz: QuizResponseItem[],
 *  loading: boolean,
 *  error: string,
 * }}
 */
export const useGetQuizList = () => {
  const [schlStudentQuiz, setSchlStudentQuiz] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { chapterId } = useParams();

  const { axiosInstance } = useAxios();

  const getSchlStudentQuizList = async (lang = "all") => {
    if (!chapterId) return;

    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/quest/chapter/quiz/${chapterId}?lang=${lang}`
      );

      //  NORMAL SUCCESS
      console.log(response);
      setSchlStudentQuiz(response?.data?.data?.quiz || []);
      return response;
    } catch (err) {
      const apiData = err?.response?.data;

      //  RESOURCE_CONFLICT → forward to component
      if (apiData?.error_code === "RESOURCE_CONFLICT") {
        setSchlStudentQuiz([]);
        return err.response; //  MOST IMPORTANT LINE
      }

      //  OTHER ERRORS
      setSchlStudentQuiz([]);
      setError(apiData?.message || ERROR_MESSAGES.UNKNOWN);
      return err.response;
    } finally {
      setLoading(false);
    }
  };

  return { schlStudentQuiz, loading, error, getSchlStudentQuizList };
};
